export const LOTS_ROUTE = 'lots/:id/:cbTabRouteId/:cbTabRouteId2';
